import React from 'react';
import { withRouter } from 'react-router-dom';
import ParcelDeleteModal from './parcel_delete_modal';
import { Button } from '@progress/kendo-react-buttons'
import queryString from 'query-string'
import Lang from '../../lang'
import services from '../../services';

var estadoAuto;
class FormNavbar extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            deletePopUp : "",
            pdfURL:null,
            selectOption:"",
            historySelectValue: ""
        }
    }

    componentDidMount(){
        (async () => { 
            let query = queryString.parse(window.location.search)
            const estado = query.codEstado
            const dataEstadoAuto = {"CodEstado" : estado}
            const CodEstadoAuto = await services.apiCall.requestApi(
            "/Fiscalizacao/GetStatusByQuery",
            dataEstadoAuto,
            "get"
            );

            if(CodEstadoAuto != null){
                estadoAuto = CodEstadoAuto
            }
        })();

        this.setSelect();
    }

    componentDidUpdate(preProps){
        if(preProps.date!==this.props.date){
            this.setSelect();
        }
    }

    handleSelect = (e) => {
        e.persist()
        console.log("the value of e is....",e)
        this.setState({
            historySelectValue : "history"
        })
    }

    setSelect=()=>{
        let selectOption=(
            <div className="col-md-3">
                {/* <div className="input-box active-grey drop-down-box">
                    <select value={this.state.historySelectValue} className="custome-drop-down" onChange={(e)=>this.handleSelect(e)} >
                        <option value="">option</option>
                        <option value="history">History</option>
                    </select>
                </div> */}
            </div>
            
        )
        this.setState({
            selectOption,
        })
    }

    openDeletePopUP = () => {
        let deletePopUp = <ParcelDeleteModal popupFor="delete" handleDelete={(status)=>this.props.handleDelete(status)} />

        this.setState({deletePopUp})
    }

    openReturnPopUP = () => {
        let returnPopUp = <ParcelDeleteModal popupFor="return" returnToFirst={(data)=>this.props.returntoFirst(data)} />

        this.setState({returnPopUp})
    }

    // goBack = () => {
    //     // console.log("Hiii",this.props)
    //     let topBarMenu = this.props.topBarMenu || {}
    //     if(this.props.to === '/rotulos'){
    //         let paramoption = {}
    //         if(this.props.parsed.evaluator == 1){
    //             paramoption = {
    //                 name: '1ª avaliação',
    //                 url: 'rotulos',
    //                 tableName: "RotulosOneAvalicao"
    //             }
    //         }else if(this.props.parsed.evaluator == 2){
    //             paramoption = {
    //                 name: '2ª avaliação',
    //                 url: 'rotulos',
    //                 tableName: "RotulosTwoAvalicao"
    //             }
    //         }else {
    //             paramoption = {
    //                 name: 'Rótulos',
    //                 url: 'rotulos',
    //                 tableName: "RotulosTotal"
    //             }
    //         }
    //         this.props.history.push({
    //             pathname : "/rotulos",
    //             state: {paramoption, topBarMenu}
    //         })
    //     }else{
    //         this.props.history.push({
    //             pathname : this.props.to,
    //             state : {topBarMenu : topBarMenu}
    //         })
    //     }
    // }
goBack = () => {
    let topBarMenu = this.props.topBarMenu || {};

    if (typeof this.props.to === 'function') {
        // Se to for uma função, chama ela
        this.props.to();
        return;
    }

    if (this.props.to === '/rotulos') {
        let paramoption = {};
        if (this.props.parsed.evaluator == 1) {
            paramoption = {
                name: '1ª avaliação',
                url: 'rotulos',
                tableName: "RotulosOneAvalicao"
            };
        } else if (this.props.parsed.evaluator == 2) {
            paramoption = {
                name: '2ª avaliação',
                url: 'rotulos',
                tableName: "RotulosTwoAvalicao"
            };
        } else {
            paramoption = {
                name: 'Rótulos',
                url: 'rotulos',
                tableName: "RotulosTotal"
            };
        }
        this.props.history.push({
            pathname: "/rotulos",
            state: { paramoption, topBarMenu }
        });
    } else {
        this.props.history.push({
            pathname: this.props.to,
            state: { topBarMenu }
        });
    }
};
    downloadPDF = async () => {
        try {
            let query = queryString.parse(window.location.search)
            if(query.id){
                let data = {
                    "id":+query.id,
                    "versao":+query.versao            
                }
                let res = await services.apiCall.requestApi('/Parcel/GetPDFById',data,'post')
                if(res){
                    services.goto.newTab('api/'+res.url)
                }
            }
        } catch (error) {
            this.setState({error})
        }
    }

    AnularAuto = async (e) => {
        var Auto = e;
        try {
            let data = {
                "idAuto": parseInt(Auto.parsed.idAuto)    
            }
            let res = await services.apiCall.requestApi('/Fiscalizacao/AnularAuto',data,'post')

            if(res){
                window.location.href='/fiscalizacao'
            }

        } catch (error) {
            this.setState({error})
        }

    }

    EmitirReceita = async (e) => {
        var Auto = e;
        window.location.href = `/revenue_criacao?&idAuto=${Auto.parsed.idAuto}`
    }

    render(){
        console.log(this.props.headName == "Gerar Documento" , "NAME PARENT");
        let query = queryString.parse(window.location.search)
        
        let id = ''
       
        if(query.id){
            id = query.id
        }
        const estado = +query.codEstado
        const DesselagemQuery = query.Desselagem

        console.log(this.props.headName)
        console.log("props navbar: ", this.props);
        return(
            <div>
            <nav className="navbar navbar-expand-md nav-bar-2 navbar-dark justify-content-end navbar-fixed-top">
                <div className="container-fluid">
                    {
                        !this.props.noCancelarEVoltarBtn ?
                        <span className="navbar-brand desktop-view min-w-300 cursor-pointer" onClick={this.goBack}>
                            <span className="k-icon k-i-arrow-left"></span> {this.props.parentName==="marcas"?"Voltar":"Cancelar e Voltar"} 
                        </span>
                        :
                        <span className="navbar-brand desktop-view min-w-300 cursor-pointer"  onClick={this.goBack}>
                            <span>
                            <span className="k-icon k-i-arrow-left"></span> {this.props.parentName==="marcas"?"Voltar":"Cancelar e Voltar"} 
                            </span>
                        </span>
                    } 

                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
                    <span className="navbar-toggler-icon"></span>
                    </button>
                    
                    {
                        Lang.langCheck.langRequest(this.props.headName) === "nº de processo" ?
                        <div className="font-23 top-head rotulos_top">
                            <span>  
                            <span className={`sivdp-icon sivdp-${this.props.type} mr-3 text-grey`}></span>
                            <span id='id-rotulo-label-id' class="main_head">Rótulo {this.props.parsed && this.props.parsed.correlativa}</span></span>
                            {
                                this.props.estado &&
                                <span className="d-md-flex pt10">
                                    <small className="rotuloTop" >
                                        {this.props.parsed && this.props.parsed.tdp}
                                        {/* {this.props.numeroAvaliacao == 0 ? "pending processos" : `${this.props.numeroAvaliacao} avaliação`} */}
                                    </small>  
                                    <small className="rotuloTop ml-2" >
                                        {this.props.parsed.estado||this.props.estado}
                                    </small>
                                </span>
                            }
                       </div> 
                       :
                       Lang.langCheck.langRequest(this.props.headName) === "MarcaPend" ?
                       <div className="font-23 top-head rotulos_top">
                           <span>  
                           <span className={`sivdp-icon sivdp-${this.props.type} mr-3 text-grey`}></span>
                           <span class="main_head">Marca {this.props.parsed && this.props.parsed.correlativa}</span></span>
                           {
                               this.props.estado &&
                               <span id='id-span-label-id' className="d-md-flex pt10">
                                   <small className="rotuloTop" >
                                       {this.props.parsed && this.props.parsed.tdp}
                                       {/* {this.props.numeroAvaliacao == 0 ? "pending processos" : `${this.props.numeroAvaliacao} avaliação`} */}
                                   </small>  
                                   <small className="rotuloTop ml-2" >
                                       {this.props.parsed.estado||this.props.estado}
                                   </small>
                               </span>
                           }
                      </div> 
                       : <div className="font-23 top-head">
                       
                           {/* {
                               this.props.headName === "Inserir Instalações" || this.props.headName === 'Inserir Instalação Vínica' ?
                               <img style={{width:"25px"}} className="mr-3 text-grey" src='/imgs/instalacoesvinicas-gray.svg' alt="" />
                               : */}
                               <span className={`sivdp-icon sivdp-${this.props.type} mr-3 text-grey`}></span>
                           {/* } */}
                            {this.props.headName === "Inserir Instalação Vínica" && this.props.isInEdit  ?"Designação da instalação":Lang.langCheck.langRequest(this.props.headName) == "Trasf" ? "Transferência de Rótulos" : Lang.langCheck.langRequest(this.props.headName)}
                            {
                                this.props.headName === "Inserir Instalação Vínica" && this.props.isInEdit ? this.state.selectOption : ""
                            }
                        </div> 
                     
                    }
                    {
                        Lang.langCheck.langRequest(this.props.headName) === 'Editar Parcela' &&
                        <div class="dropdown ml-5">
                        <Button primary={false} className="btn-ivdp-secondary mr-2 btn-sm dropdown-toggle" data-toggle="dropdown">
                            {("Opções").toUpperCase()}
                            <i class="fa fa-angle-down ml-3" aria-hidden="true"></i>
                        </Button>
                        <ul class="dropdown-menu">
                            <li className="dropdown-item cursor-pointer" data-toggle="modal" data-target="#google-map-popup" ><span>Ver no mapa <i className="fas fa-map-marker float-right mt-1"></i></span></li>
                            <li className="dropdown-item cursor-pointer" aria-disabled={true}><span>Dividir <span className="k-icon k-i-align-remove float-right mt-1"></span></span></li>
                            <li className="dropdown-item cursor-pointer" onClick={()=>this.downloadPDF()} ><a>Imprimir <i className="fas fa-print float-right mt-1"></i></a></li>
                        </ul>
                        </div>
                    }
                    {/* {
                        Lang.langCheck.langRequest(this.props.headName) === "nº de processo" ?
                        this.props.parsed.codEstado == 4 || this.props.parsed.codEstado == 5 ?
                        (
                            <div className="collapse navbar-collapse justify-content-end" id="collapsibleNavbar">
                                <ul className="navbar-nav">
                                    <li className="nav-item">
                                        <Button onClick={(e)=>this.props.handleSubmit(e,this.props.to)} primary={true} className="btn-ivdp-primary mr-2 btn-sm" data-toggle='modal' data-target={"#groupPopup"}>Gravar e Sair</Button>
                                        <Button onClick={()=>this.props.handleSave()} primary={true} className="btn-ivdp-primary mr-2 btn-sm">Gravar</Button>
                                        <Button className="mr-2 k-primary btn-ivdp-secondary btn-theme remoove ml-2 text-danger" onClick={this.goBack}>Cancelar</Button>  
                                    </li>
                                </ul>
                            </div>        
                        )
                        :
                        <div className="collapse navbar-collapse justify-content-end" id="collapsibleNavbar"></div>
                        :
                        (<></>)
                    } */}
                    {
                        Lang.langCheck.langRequest(this.props.headName) === "nº de processo" ?
                        this.props.parsed.codEstado == 2 || this.props.parsed.codEstado == 6 ?
                       
                        (
                            <div className="collapse navbar-collapse justify-content-end" id="collapsibleNavbar">
                                <ul className="navbar-nav">
                                    <li className="nav-item">
                                    {
                                    this.props.parsed.estado==="Sob Análise" ?<>
                                    <Button primary={true} onClick={()=>this.props.handleLibertar()} className="btn-ivdp-primary mr-2 btn-sm">Libertar Processo</Button>
                                            <Button primary={true} className="btn-ivdp-primary mr-2 btn-sm" onClick={this.goBack}>Cancelar</Button>
                                            </>
                                            :
                                            <>
                                        {
                                            this.props.evaluator&&
                                            <>
                                                {
                                                    this.props.pendingCases &&
                                                    <Button primary={true} onClick={()=>this.props.handleLibertar()} className="btn-ivdp-primary mr-2 btn-sm">Libertar Processo</Button>
                                                }
                                                {

                                                this.props.parsed.from!=="marcas" && this.props.parsed.from !=="marcasPendentes" && this.props.parsed.from !=="marcasApproved" &&this.props.showReturnButton &&
                                                <Button data-toggle="modal" data-target="#popup-return" onClick={()=>this.openReturnPopUP()} primary={true} className="btn-ivdp-primary btn-sm">Retornar para 1ª Avaliação</Button>  
                                                }
                                            </>
                                        }
                                        {
                                            this.props.parsed.estado==="Pendente - Devolvido" &&
                                    <Button primary={true} onClick={()=>this.props.handleLibertar()} className="btn-ivdp-primary mr-2 btn-sm">Libertar Processo</Button>

                                        }
                                        {
                                            this.props.parsed.from !=="marcasApproved" &&
                                            <>
                                            {
                                                this.props.parsed.from !=="marcasPendentes" && this.props.parsed.from !=="rotulos" &&
                                                <Button onClick={()=>this.props.handleSave()} primary={true} className="btn-ivdp-primary mr-2 btn-sm">Gravar</Button>
                                            }
                                            {
                                                this.props.parsed.from !=="rotulos" &&
                                                <Button onClick={()=>this.props.handleSubmit()} primary={true} className="btn-ivdp-primary btn-sm">Submeter</Button>
                                            }
                                                
                                            </>
                                        }
                                            </>
                                    }
                                    {
                                        this.props.showMarcasButton&&<>
                                        <Button primary={true} className="btn-ivdp-primary mr-2 btn-sm" data-toggle="modal" data-target="#marca-suspend">Cancelar Marca</Button>
                                        <Button primary={true} className="btn-ivdp-primary mr-2 btn-sm" data-toggle="modal" data-target="#marca-activate" >Suspender Marca</Button>
                                        </>
                                    }
                                        
                                    </li>
                                </ul>
                            </div>        
                        )
                        :
                        <div className="collapse navbar-collapse justify-content-end" id="collapsibleNavbar">
                                <ul className="navbar-nav">
                                    <li className="nav-item">
                                        <Button id='id-button-submit-exit' onClick={(e)=>this.props.handleSubmit(e,this.props.to)} primary={true} className="btn-ivdp-primary mr-2 btn-sm" data-toggle='modal' data-target={"#groupPopup"}>Gravar e Sair</Button>
                                        {/* <Button onClick={()=>this.props.handleSave()} primary={true} className="btn-ivdp-primary mr-2 btn-sm">Gravar</Button> */}
                                        {/* <Button className="mr-2 k-primary btn-ivdp-secondary btn-theme remoove ml-2 text-danger" onClick={this.goBack}>Cancelar</Button>   */}
                                    </li>
                                </ul>
                            </div> 
                        :
                        <div className="collapse navbar-collapse justify-content-end" id="collapsibleNavbar">
                            {
                                !this.props.hideButton && (
                                    <ul className="navbar-nav">
                                        <li className="nav-item">
                                            {
                                                // Lang.langCheck.langRequest(this.props.headName) === "Trasf" ?(
                                                // <>
                                                //  <div className="collapse navbar-collapse justify-content-end" id="collapsibleNavbar"></div>
                                                // </>
                                                 
                                                // ):
                                                ( <>{
                                                    
                                                    this.props.parentName==="Utilizador" ? (
                                                    <>
                                                        <Button onClick={(e)=>this.props.handleSubmit(e,this.props.to)} primary={true} className="btn-ivdp-primary mr-2 btn-sm" data-toggle='modal' data-target={"#groupPopup"}>Guardar e Sair</Button>
                                                        {/* <Button onClick={(e)=>this.props.handleSubmit(e)} primary={true} className="btn-ivdp-primary btn-sm" data-toggle='modal' data-target={"#groupPopup"}>Guardar</Button> */}
                                                    </>
    
                                                    ):
                                                        this.props.headName == "Gerar Documento" ? (
                                                        <>
                                                            <Button onClick={(e)=>this.props.handleSubmit(e,this.props.to)} primary={true} className="btn-ivdp-primary mr-2 btn-sm" data-toggle='modal' data-target={"#groupPopup"}>Submeter</Button>
                                                            {/* <Button onClick={(e)=>this.props.handleSubmit(e)} primary={true} className="btn-ivdp-primary btn-sm" data-toggle='modal' data-target={"#groupPopup"}>Guardar</Button> */}
                                                        </>
        
                                                        ):
                                                        this.props.headName == "Trasf" ? (
                                                            <>
                                                                <Button onClick={(e)=>this.props.handleSubmit(e,this.props.to)} primary={true} className="btn-ivdp-primary mr-2 btn-sm" data-toggle='modal' data-target={"#groupPopup"}>Submeter</Button>
                                                                {/* <Button onClick={(e)=>this.props.handleSubmit(e)} primary={true} className="btn-ivdp-primary btn-sm" data-toggle='modal' data-target={"#groupPopup"}>Guardar</Button> */}
                                                            </>
            
                                                        ):
                                                        this.props.headName == "Gestão de Autos" && estadoAuto == 2 && DesselagemQuery != "true"  ? (
                                                            
                                                            <>
                                                                <Button onClick={(e)=> this.AnularAuto(this.props)} primary={true} className="btn-ivdp-primary mr-2 btn-sm teste" data-toggle='modal' data-target={"#groupPopup"}>Anular</Button>
                                                                <Button onClick={(e)=> this.EmitirReceita(this.props)} primary={true} id="EmitirReceitaButton" className="btn-ivdp-primary mr-2 btn-sm teste" data-toggle='modal' data-target={"#groupPopup"}>Emitir Receita</Button>
                                                            </>
                                                            
            
                                                        )
                                                        : this.props.headName == 'Gestão de Autos' && estadoAuto != 3 ? (
                                                    <>
                                                                <Button onClick={(e) => this.props.handleConcluir(e,this.props.to)} primary={true} className="btn-ivdp-primary mr-2 btn-sm" data-toggle='modal' data-target={"#groupPopup"}>Concluir</Button>
                                                                <Button onClick={(e)=>this.props.handleSubmit(e,this.props.to)} primary={true} className="btn-ivdp-primary mr-2 btn-sm" data-toggle='modal' data-target={"#groupPopup"}>Guardar e Sair</Button>
                                                                

                                                                
                                                    </>
                                                        ) : estadoAuto != 3 ? (
                                                            <Button onClick={(e)=>this.props.handleSubmit(e,this.props.to)} primary={true} className="btn-ivdp-primary mr-2 btn-sm" data-toggle='modal' data-target={"#groupPopup"}>Guardar e Sair</Button>
                                                        ) : ""
                                                }</> ||
                                                (<>{
                                                    this.props && this.props.showDelete && id ?(<>
                                                    <Button data-toggle="modal" data-target="#popup-delete" onClick={()=>this.openDeletePopUP()} className="mr-2 k-primary btn-ivdp-secondary btn-theme remoove ml-2 text-danger">Eliminar</Button>
                                                    </>):(<>{
                                                    (this.props.parsed &&this.props.parsed.from!=="rutulo_processos" && this.props.parsed.estado==="Aprovado")||(this.props.parentName==="Utilizador")?null:
                                                    <Button className="mr-2 k-primary btn-ivdp-secondary btn-theme remoove ml-2 text-danger" onClick={this.goBack}>Cancelar</Button>
                                                    }</> )}</>))
                                                
                                            }
                                         
                                        </li>
                                    </ul>
                                )
                            }
                        </div>
                         
                    }
                    {/* Transferencias */}
                    {
                        console.log(Lang.langCheck.langRequest(this.props.headName) , "transferencias lang3")
                        // Lang.langCheck.langRequest(this.props.headName) === "Trasf" 
                        // (
                        //     <div className="collapse navbar-collapse justify-content-end" id="collapsibleNavbar">
                        //         <ul className="navbar-nav">
                        //             <li className="nav-item">
                                        
                        //             </li>
                        //         </ul>
                        //     </div>        
                        // ) 
                    }
                    {/* END Transferencias */}
                </div>
                
            </nav>
            <div className="modal fade" id="popup-delete">
                <div className="modal-dialog modal-dialog-centered">
                    {this.state.deletePopUp}
                </div>
                </div>
                <div className="modal fade" id="popup-return">
                <div className="modal-dialog modal-dialog-centered">
                    {this.state.returnPopUp}
                </div>
                </div>
                </div>
            
        )
    }
}

export default withRouter(FormNavbar);